import Feature28 from './Feature28'
export default Feature28
